import { connect } from 'react-redux';
import { contactResellerSelector } from '../../../../../../../../redux/landings/landings.selectors';
import { ContactFormComponent } from './contact-form';
export const ContactForm = connect(contactResellerSelector)(ContactFormComponent);